import { memo } from 'react';
import DeleteButton from 'components/Actions/DeleteAction/DeleteButton';
import { useProductDetail } from '../../contexts/ProductDetail';
import { useDeleteProduct } from '../../hooks/useDeleteProduct';
import { PRODUCT_ERRORS } from '../../constants/errors';

const ProductDeleteButton = () => {
  const { id } = useProductDetail();
  const { mutate, isPending, error } = useDeleteProduct(id, () => 'void', true);
  return <DeleteButton isLoading={isPending} onDelete={mutate} error={error} errors={PRODUCT_ERRORS} />;
};

export default memo(ProductDeleteButton);
